// Datos MOCK del historial de facturas de la suscripción (Fase 1, front-only).
// Sirven para diseñar/ver el flujo completo (historial → factura → detalle)
// SIN backend. En Fase 2 el motor AFIP del payment-server puebla la tabla
// `facturas_suscripcion` y esto se reemplaza por un fetch real.
// Ver ADR-2026-08-03-facturacion-pantalla-propia-fullscreen.

export interface FacturaMock {
  id: string;
  fecha: string; // ISO — fecha de pago/emisión
  periodoDesde: string; // ISO
  periodoHasta: string; // ISO
  tipo: 'A' | 'B' | 'C';
  numero: string; // nº de comprobante AFIP (pto vta - correlativo)
  plan: string;
  neto: number; // ARS sin IVA
  iva: number; // ARS
  total: number; // ARS
  estado: 'emitida' | 'pendiente';
  metodo: string; // ej. "Mastercard ···· 0530"
}

export const FACTURAS_MOCK: FacturaMock[] = [
  {
    id: 'fac_202607',
    fecha: '2026-07-27',
    periodoDesde: '2026-07-27',
    periodoHasta: '2026-08-27',
    tipo: 'A',
    numero: '00001-00000012',
    plan: 'Básico',
    neto: 18000,
    iva: 3780,
    total: 21780,
    estado: 'emitida',
    metodo: 'Mastercard ···· 0530',
  },
  {
    id: 'fac_202606',
    fecha: '2026-06-27',
    periodoDesde: '2026-06-27',
    periodoHasta: '2026-07-27',
    tipo: 'A',
    numero: '00001-00000009',
    plan: 'Básico',
    neto: 18000,
    iva: 3780,
    total: 21780,
    estado: 'emitida',
    metodo: 'Mastercard ···· 0530',
  },
  {
    id: 'fac_202605',
    fecha: '2026-05-27',
    periodoDesde: '2026-05-27',
    periodoHasta: '2026-06-27',
    tipo: 'A',
    numero: '00001-00000006',
    plan: 'Básico',
    neto: 18000,
    iva: 3780,
    total: 21780,
    estado: 'emitida',
    metodo: 'Mastercard ···· 0530',
  },
];

export const getFacturaMock = (id: string | undefined): FacturaMock | null =>
  id ? FACTURAS_MOCK.find((f) => f.id === id) ?? null : null;
